// extracted by mini-css-extract-plugin
export default {"card":"Rank_card__lW1am","vote":"Rank_vote__4VpOM","cardTitle":"Rank_cardTitle__GBgLQ","caption":"Rank_caption__u65TZ"};